// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import OEProductTypeSelectorTemplate from '@front/templates/OEProductTypeSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { WDSettings } from '../../settings/WDGeneralSettings';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class OEProductTypeSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'OEProductTypeSelector';
    }
    oninit() {
        super.oninit();
        this.observe('selectedItem', this.updateProductType);
        this.observe('productType', this.onProductTypeChange);
        this.observe('instrument account', this.repopulate);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set('label', Resources.getResource('panel.newOrderEntry.ProductType'));
    }
    updateProductType(selectedItem) {
        void this.set('productType', selectedItem ? selectedItem.value : null);
    }
    onProductTypeChange(value) {
        const selItem = this.get('selectedItem');
        const items = this.get('items');
        if (items && selItem && selItem.value != value) {
            for (let i = 0; i < items.length; i++) {
                if (items[i].value == value) {
                    void this.set('selectedItem', items[i]);
                }
            }
        }
    }
    repopulate() {
        const instrument = this.get('instrument');
        const account = this.get('account');
        const insID = !isNullOrUndefined(instrument) ? instrument.GetInteriorID() : null;
        const dict = !isNullOrUndefined(account === null || account === void 0 ? void 0 : account.RiskPlan)
            ? account.RiskPlan.GetRisksForInstrument(insID).availableProductTypes
            : InstrumentUtils.getAllowedProductTypeDict(instrument);
        if (isNullOrUndefined(instrument) || isNullOrUndefined(account) || dict.length === 0) {
            void this.set('visible', false);
            return;
        }
        const items = dict.map(function (productType) {
            return {
                type: NewContextMenuItemType.Default,
                value: productType,
                text: InstrumentUtils.GetLocalizedProductType(instrument, productType),
                selected: productType === WDSettings.productType
            };
        });
        const visible = items[0].value !== ProductType.General; // при ProductType.General скрываем комбобокс
        const enabled = items.length !== 1; // при единственном ProductType делаем комбобокс enabled
        void this.set({
            items,
            visible,
            enabled
        });
    }
}
ContainerControl.extendWith(OEProductTypeSelector, {
    template: OEProductTypeSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            account: null,
            items: null,
            selectedItem: null,
            productType: null,
            showLastValue: false,
            visible: false,
            enabled: true,
            showLabel: true,
            width: 198,
            tooltip: 'OEProductTypeSelector.tooltip'
        };
    }
});
